import app from 'flarum/forum/app';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
import Modal from 'flarum/common/components/Modal';
export default class SelectAvatarModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.cfg = null;
    this.folderActive = null;
    this.loadConfig();
  }
  loadConfig() {
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/mz-avatar-custom-cfg`
    }).then(data => {
      this.cfg = data.data;
      this.loading = false;
      this.folderActive = data.data.folderActive;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      app.alerts.show({
        type: 'error',
        content: '配置加载失败'
      });
    });
  }
  className() {
    return 'SelectAvatarModal Modal--flat Modal--large';
    return 'SelectAvatarModal Modal--flat Modal--medium';
  }
  title() {
    return '选择头像';
  }
  setTab(folder) {
    this.folderActive = folder;
    m.redraw();
  }
  content() {
    // 加载中
    if (this.loading) {
      return m('.Modal-body', '加载中...');
    }

    // 没有数据
    if (!this.cfg) {
      return m('.Modal-body', '无数据');
    }
    return m('div.Modal-body', [m('div.Tabs', [
    // Tab
    m('div.Tabs-nav', this.cfg.avatars.map(item => m('button.Button.Button--link[type=button]', {
      //class: this.folderActive === item.folder ? 'active' : '',
      active: this.folderActive === item.folder ? '' : undefined,
      onclick: () => this.setTab(item.folder)
    }, [m('span.Button-label', m('span.Button-labelText', `${item.folder} (${item.count})`))]))),
    // Content
    m('div', {
      class: 'Tabs-content SearchModal-tabs-content'
    }, [this.cfg.avatars.map(item => this.folderActive === item.folder && m('div.SearchModal-section', [m('hr.Modal-divider'), m('div', {
      class: 'UserCard-avatar Mz-Avatar'
    }, [
    //`当前 folder：${item.folder}`

    Array.from({
      length: item.count
    }, (_, i) => {
      const idx = i + 1;
      const avatarFileName = `${this.cfg.folder}/${item.folder}/${idx}.png`;
      const url = `/assets/avatars/${avatarFileName}`;
      return m('img.Mz-AvatarItem.Avatar', {
        src: url,
        onclick: () => this.selectAvatar(avatarFileName)
      });
    })])]))])])]);
  }
  selectAvatar(avatarFileName) {
    const user = this.attrs.user;
    if (!user) {
      app.alerts.show({
        type: 'error'
      }, '用户数据获取失败');
      return;
    }
    app.request({
      method: 'POST',
      url: `${app.forum.attribute('apiUrl')}/users/${user.id()}/mz-avatar-custom`,
      body: {
        avatarUrl: avatarFileName
      }
    }).then(data => {
      app.alerts.show({
        type: 'success'
      }, '头像已更新');
      app.store.pushPayload(data);
      /*app.store.pushPayload({
      	data: {
      		type: 'users',
      		id: user.id(),
      		attributes: {
      			avatarUrl: `/assets/avatars/${data.avatar_url}` 
      		}
      	}
      });*/
      m.redraw();
    }).catch(err => {
      app.alerts.show({
        type: 'error'
      }, '头像更新失败');
    });
    app.modal.close();
  }
}
app.initializers.add('mz-avatar-selection', () => {
  AvatarEditor.prototype.upload = function () {
    const user = this.attrs.user;
    app.modal.show(SelectAvatarModal, {
      user: user
    });
    return false;
  };
  AvatarEditor.prototype.openPicker = function () {
    const user = this.attrs.user;
    app.modal.show(SelectAvatarModal, {
      user: user
    });
    return false;
  };

  /*extend(AvatarEditor.prototype, 'openPicker', function () {
  	console.log(AvatarEditor.prototype.loading);
  	console.log(AvatarEditor.prototype.attrs.user);
  		console.log('用户取消了上传2');
  		return false;
  });*/
});